import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

export const getScheduleFlow = asyncThunkWrapper({ 
  model: 'scheduleFlows', 
  action: 'getScheduleFlow', 
  func: async () => {
    const attributes = [
      'id', 
      'appointment_prompt', 
      'booking_prompt',
      'patient_prompt', 
      'clinicians_prompt',
      'offset_prompt',
      'filter_slots_prompt', 
      'message',
      'no_slots_message',
      'pull',
      'schedule_start_at',
      'schedule_end_at',
      'schedule_weekdays', 
      'updated_at'
    ];
    const params = { attributes };
    const response = await axios.get(`/schedule_flow`, { params });

    return response.data;
  } 
});
export const createScheduleFlow = asyncThunkWrapper({ 
  model: 'scheduleFlows', 
  action: 'createScheduleFlow', 
  func: async (schedule_flow) => {
    const attributes = [
      'id', 
      'appointment_prompt', 
      'booking_prompt',
      'patient_prompt', 
      'clinicians_prompt',
      'offset_prompt',
      'filter_slots_prompt', 
      'message',
      'no_slots_message',
      'pull',
      'schedule_start_at',
      'schedule_end_at',
      'schedule_weekdays',
      'updated_at'
    ];
    const response = await axios.post(`/schedule_flow`, { schedule_flow, attributes });

    return response.data;
  } 
});
export const updateScheduleFlow = asyncThunkWrapper({ 
  model: 'scheduleFlows', 
  action: 'updateScheduleFlow', 
  func: async (schedule_flow) => {
    const response = await axios.patch(`/schedule_flow`, { schedule_flow });

    return { status: response.status, schedule_flow };
  } 
});
export const deleteScheduleFlow = asyncThunkWrapper({ 
  model: 'scheduleFlows', 
  action: 'deleteScheduleFlow', 
  func: async () => {
    const response = await axios.delete(`/schedule_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveScheduleFlow = createAction('scheduleFlows/clearLocalActiveScheduleFlow');